<template>
  <div id="vue-results">
    <SearchResultsText v-if="settings.searchBoxPlacement === 'top'"/>
    <div
      class="listing listing--lender"
      v-for="(result, i) in searchResults"
      :key="result.key"
    >

      <div class="listing__image" v-if="result.image">
        <img :src="result.image" :alt="result.title" />
      </div>

      <div class="listing__wrapper">
        <div class="listing__content-wrapper">

          <div class="listing__content">
            <div class="listing__title">
              <p>{{ result.title }}</p>
            </div>
            <p class="listing__subtitle">{{ result.meta.company }}</p>
            <div class="listing__details">
              <div class="listing__phone listing__icon" v-if="result.meta && result.meta.phone">
                <SVGLoader icon="phone" :width="32" :height="32"/>
                <span>{{ result.meta.phone }}</span>
              </div>
              <div class="listing__email listing__icon" v-if="result.meta && result.meta.email">
                <SVGLoader icon="email" :width="20" :height="20"/>
                <a :href="`mailto:${result.meta.email}`">{{ result.meta.email }}</a>
              </div>
            </div>

            <p class="listing__nmls" v-if="result.meta && result.meta.nmlsNum">NMLS# {{ result.meta.nmlsNum }}</p>
          </div>

          <div class="listing__additional" v-if="result.meta && result.meta.languages || result.meta.award">
            <div class="listing__additional-languages" v-if="result.meta && result.meta.languages && result.meta.languages.length">
              <span class="listing__additional-languages-title">Additional Languages:</span>
              <span class="listing__additional-languages-value">{{result.meta.languages.join(', ')}}</span>
            </div>
            <div
              class="listing__additional-advisor"
              v-if="result.meta && result.meta.advisor"
            >
              <SVGLoader icon="advisors" :width="32" :height="32"/>
              <span class="listing__additional-advisor-title">Lender Advisory Group Member</span>
            </div>
            <div
              class="listing__additional-award"
              v-if="result.meta && result.meta.award"
              :class="`award-${result.meta.award.toLowerCase()}`"
            >
              <p class="listing__additional-award-title">Previous Year Percentile</p>
              <div class="listing__additional-award-value">
                <SVGLoader icon="award" :width="26" :height="26" :htmlAttrs="{ class: `award-${result.meta.award.toLowerCase()}` }" />
                <span>{{ result.meta.award }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

        <div class="listing__serving" v-if="result.meta && result.meta.serving && result.meta.serving.length">
          <span class="listing__serving-title">Serving:</span>
          <span class="listing__serving-value" v-for="r in result.meta.serving">
            <SVGLoader icon="house" :width="16" :height="16"/>
            {{r}}
          </span>
        </div>
    </div>
  </div>
</template>

<script>
import SVGLoader from '../global/SVGLoader.vue';
import SearchResultsText from '../SearchResultsText.vue';

export default {
  components: {
    SVGLoader,
    SearchResultsText,
  },
  computed: {
    searchResults: function () {
      if (!this.$root.devData) return this.$store.state.results.itemResults;

      return this.$store.state.results.itemResults.map((result, i) => {
        return {
          ...result,
          meta: {
            ...result.meta,
            award: i < 2 ? 'Gold Production' : i === 2 ? 'Silver Production' : i === 3 ? 'Bronze Production' : null,
            advisor: i == 0,
          },
        };
      });
    },
    settings: function () {
      return this.$store.state.settings;
    },
  },
  methods: {
    getAriaText: function (item) {
      if (item != null) {
        return 'Click to go to ' + item.title;
      } else {
        return '';
      }
    },
  },
};
</script>